import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import SelectUser from 'components/Accounts/SelectUser';

import { admin } from 'variables/userAccountTypes';

//PurchaseOrders have to be Approved before payments can be made.
const mapStateToProps = (state) => ({
  activeUserType: state.activeUserType,
  salesOrders: state.salesOrders,
  purchaseOrders: state.purchaseOrders.filter(purchaseOrder => purchaseOrder.payments.length > 0),
  returnOrders: state.returnOrders,
  expenses: state.expenses,
  products: state.products,
  customers: state.customers,
  vendors: state.vendors,
  user: state.user
});

const Accounts = (props) => (
  <>
    <Helmet>
      <title>Accounts | Duot One</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <SelectUser
          salesOrders={props.salesOrders}
          purchaseOrders={props.purchaseOrders}
          returnOrders={props.returnOrders}
          expenses={props.expenses}
          products={props.products}
          customers={props.customers}
          vendors={props.vendors}
          user={props.user}
          userIsAdmin={props.activeUserType === admin}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (Accounts);
